import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_CONFIG from './config/api';

const JornadaVeiculoModal = ({ veiculoId, onClose }) => {
  const [jornada, setJornada] = useState([]);
  const [veiculo, setVeiculo] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 5;

  useEffect(() => {
    carregarJornada();
  }, [veiculoId]);

  const carregarJornada = async () => {
    setCarregando(true);
    setErro('');

    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${API_CONFIG.API_URL}/veiculos/${veiculoId}/jornada`,
        {
          headers: { 'x-auth-token': token }
        }
      );

      if (response.data.success) {
        setVeiculo(response.data.veiculo);
        setJornada(response.data.jornada);
      }
    } catch (error) {
      setErro('Erro ao carregar jornada do veículo');
    } finally {
      setCarregando(false);
    }
  };

  const formatarData = (data) => {
    if (!data) return 'N/A';
    const d = new Date(data);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getTipoLabel = (tipo) => {
    return tipo === 'cadastro' ? 'Cadastro' : 'Movimentação';
  };

  const getTipoColor = (tipo) => {
    return tipo === 'cadastro' ? '#27ae60' : '#3498db';
  };

  const getTotalPaginas = () => {
    return Math.ceil(jornada.length / itensPorPagina);
  };

  const getJornadaPaginada = () => {
    const inicio = (paginaAtual - 1) * itensPorPagina;
    const fim = inicio + itensPorPagina;
    return jornada.slice(inicio, fim);
  };

  const mudarPagina = (novaPagina) => {
    if (novaPagina >= 1 && novaPagina <= getTotalPaginas()) {
      setPaginaAtual(novaPagina);
    }
  };

  return (
    <div className="modal-overlay-preencher">
      <div className="modal-preencher-container" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
        <div className="modal-preencher-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
            <h2>Jornada do Veículo</h2>
          </div>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>

        <div style={{ padding: '1.5rem', overflowY: 'auto', flex: 1 }}>
          {carregando ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>
              Carregando jornada...
            </div>
          ) : erro ? (
            <div style={{
              padding: '1rem',
              background: '#fee',
              color: '#c00',
              borderRadius: '4px',
              textAlign: 'center'
            }}>
              {erro}
            </div>
          ) : (
            <>
              {/* Informações do Veículo */}
              {veiculo && (
                <div style={{
                  background: '#f8f9fa',
                  padding: '1rem',
                  borderRadius: '8px',
                  marginBottom: '1.5rem',
                  border: '1px solid #e0e0e0'
                }}>
                  <h3 style={{ margin: 0, marginBottom: '0.5rem', fontSize: '1.1rem', color: '#c14427' }}>
                    {veiculo.marca} {veiculo.modelo}
                  </h3>
                  <div style={{ fontSize: '0.9rem', color: '#666' }}>
                    <strong>Placa:</strong> {veiculo.placa ? veiculo.placa.replace(/-/g, '') : ''} |
                    <strong> Ano:</strong> {veiculo.ano_fabricacao}/{veiculo.ano_modelo}
                  </div>
                </div>
              )}

              {/* Timeline da Jornada */}
              {jornada.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>
                  Nenhum registro de jornada encontrado
                </div>
              ) : (
                <>
                  <div style={{ position: 'relative', minHeight: '200px' }}>
                    {/* Linha vertical da timeline */}
                    <div style={{
                      position: 'absolute',
                      left: '20px',
                      top: '10px',
                      bottom: '10px',
                      width: '2px',
                      background: '#e0e0e0'
                    }} />

                    {/* Pontos da jornada paginados */}
                    {getJornadaPaginada().map((ponto, index) => (
                      <div
                        key={index}
                        style={{
                          position: 'relative',
                          paddingLeft: '50px',
                          paddingBottom: '1.5rem',
                          marginBottom: index !== getJornadaPaginada().length - 1 ? '1rem' : 0
                        }}
                      >
                        {/* Marcador circular */}
                        <div style={{
                          position: 'absolute',
                          left: '11px',
                          top: '0',
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          background: getTipoColor(ponto.tipo),
                          border: '3px solid white',
                          boxShadow: '0 0 0 2px ' + getTipoColor(ponto.tipo),
                          zIndex: 1
                        }} />

                        {/* Conteúdo do ponto */}
                        <div style={{
                          background: 'white',
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          padding: '1rem',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                        }}>
                          {/* Cabeçalho */}
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: '0.75rem'
                          }}>
                            <div>
                              <div style={{
                                display: 'inline-block',
                                background: getTipoColor(ponto.tipo),
                                color: 'white',
                                padding: '3px 10px',
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                fontWeight: '600',
                                marginBottom: '0.5rem'
                              }}>
                                {getTipoLabel(ponto.tipo)}
                              </div>
                              <div style={{ fontSize: '1rem', fontWeight: '600', color: '#333' }}>
                                📍 {ponto.localizacao}
                              </div>
                            </div>
                            <div style={{
                              fontSize: '0.95rem',
                              color: '#444',
                              fontWeight: '600',
                              textAlign: 'right',
                              minWidth: '140px',
                              background: '#f0f2f5',
                              padding: '4px 10px',
                              borderRadius: '6px',
                              border: '1px solid #e0e0e0'
                            }}>
                              {formatarData(ponto.data)}
                            </div>
                          </div>

                          {/* Informações adicionais */}
                          <div style={{ fontSize: '0.9rem', color: '#666' }}>
                            {ponto.condutor_nome && (
                              <div style={{ marginBottom: '0.25rem' }}>
                                <strong>Condutor:</strong> {ponto.condutor_nome}
                              </div>
                            )}
                            {ponto.observacao && (
                              <div style={{
                                marginTop: '0.5rem',
                                padding: '0.5rem',
                                background: '#f8f9fa',
                                borderRadius: '4px',
                                fontStyle: 'italic',
                                color: '#555'
                              }}>
                                {ponto.observacao}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Paginação Moderna */}
                  {getTotalPaginas() > 1 && (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '8px',
                      marginTop: '1.5rem',
                      padding: '1rem',
                      background: '#f8f9fa',
                      borderRadius: '8px'
                    }}>
                      <button
                        onClick={() => mudarPagina(paginaAtual - 1)}
                        disabled={paginaAtual === 1}
                        className="btn btn-secondary"
                        style={{
                          padding: '8px 16px',
                          opacity: paginaAtual === 1 ? 0.5 : 1,
                          cursor: paginaAtual === 1 ? 'not-allowed' : 'pointer'
                        }}
                      >
                        ← Anterior
                      </button>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        {[...Array(getTotalPaginas())].map((_, i) => (
                          <button
                            key={i}
                            onClick={() => mudarPagina(i + 1)}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '6px',
                              border: '1px solid #e0e0e0',
                              background: paginaAtual === i + 1 ? '#c14427' : 'white',
                              color: paginaAtual === i + 1 ? 'white' : '#333',
                              fontWeight: paginaAtual === i + 1 ? '600' : '400',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            onMouseEnter={(e) => {
                              if (paginaAtual !== i + 1) {
                                e.target.style.background = '#f0f0f0';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (paginaAtual !== i + 1) {
                                e.target.style.background = 'white';
                              }
                            }}
                          >
                            {i + 1}
                          </button>
                        ))}
                      </div>

                      <button
                        onClick={() => mudarPagina(paginaAtual + 1)}
                        disabled={paginaAtual === getTotalPaginas()}
                        className="btn btn-secondary"
                        style={{
                          padding: '8px 16px',
                          opacity: paginaAtual === getTotalPaginas() ? 0.5 : 1,
                          cursor: paginaAtual === getTotalPaginas() ? 'not-allowed' : 'pointer'
                        }}
                      >
                        Próxima →
                      </button>
                    </div>
                  )}

                  {/* Contador de registros */}
                  <div style={{
                    textAlign: 'center',
                    marginTop: '1rem',
                    fontSize: '0.85rem',
                    color: '#666'
                  }}>
                    Mostrando {((paginaAtual - 1) * itensPorPagina) + 1} a {Math.min(paginaAtual * itensPorPagina, jornada.length)} de {jornada.length} registros
                  </div>
                </>
              )}
            </>
          )}

          {/* Botão Fechar */}
          <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'flex-end' }}>
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{ padding: '10px 24px' }}
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JornadaVeiculoModal;
